import React from "react";

const MaintenanceUpdates = () => {
  const updates = [
    {
      title:
        "Wallet Maintenance for USDC Withdrawals on Avalanche C-Chain (AVAX-C) Network - 2025-08-22",
      date: "2025-08-21",
    },
    {
      title:
        "Tillionx Will Support the Viction (VIC) Network Upgrade & Hard Fork - 2025-08-21",
      date: "2025-08-20",
    },
    {
      title:
        "Tillionx Will Support the Fusionist (ACE) Network Upgrade & Hard Fork - 2025-08-20",
      date: "2025-08-18",
    },
    {
      title:
        "Tillionx Will Cease Support for Deposits and Withdrawals of Tokens on the Neo Legacy Network - 2025-08-25",
      date: "2025-08-18",
    },
    {
      title:
        "Tillionx Completes Integration of Hedera (HBAR) and Sui (SUI) on BNB Smart Chain (BSC) Network, Opens Deposits and Withdrawals - 2025-08-15",
      date: "2025-08-15",
    },
    {
      title:
        "Tillionx Will Support the Near Protocol (NEAR) Network Upgrade & Hard Fork - 2025-08-18",
      date: "2025-08-15",
    },
    {
      title:
        "Tillionx Will Support the Terra Luna Classic (LUNC) Network Upgrade - 2025-08-15",
      date: "2025-08-15",
    },
  ];
  return <div>
    <div className="my-16 rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans">
      <nav className="flex items-center text-sm  mb-6">
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Maintenance Updates</span>
        </nav>
      <h2 className="text-xl font-bold mb-6">Maintenance Updates</h2>

      {/* Updates List */}
      {updates.map((item, index) => (
        <div key={index} className="py-4 border-b border-gray-200 last:border-b-0">
          <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
            {item.title}
          </h3>
          <p className="text-sm mt-1">{item.date}</p>
        </div>
      ))}
    </div>
  </div>;
};

export default MaintenanceUpdates;
